// extracted by mini-css-extract-plugin
module.exports = {"sitewideAlertBanner":"az_phc","sitewideAlertBannerIconWrapper":"az_qhc","sitewideAlertBannerIcon":"az_rhc","sitewideAlertBannerText":"az_shc"};